<template>
    <!-- ===== 01 顶部定位区 Hero ===== 科技蓝渐变 + 核心关键词 -->
    <section class="gradient-blue relative">
        <div class="max-w-6xl mx-auto px-4 sm:px-8 lg:px-10 md:py-12">
            <div class="max-w-5xl"> <!-- 左侧内容区 -->
                <!-- <h1 class="text-white/90"> -->
                     <h1 style="color: #fff;">
                       从战略到落地，<br>数据咨询，让数据与AI驱动增长  <br>
                </h1>
                <p class="mt-6 text-xl text-white/80 max-w-2xl">
                    古杉数据提供全栈式企业级咨询服务——数字化转型、数据治理、AI及大模型创新，以及数据监理订阅服务，以灵活模式开启长期价值。
                </p>

                <!-- 关键词云（SEO强化） -->
                <div class="rc-keyword-cloud">
                    <h2 class="rc-keyword-tag highlight">AI及大模型咨询</h2>
                    <h2 class="rc-keyword-tag highlight">数据治理</h2>
                    <h2 class="rc-keyword-tag highlight">数智化转型</h2>
                    <h2 class="rc-keyword-tag">数字化转型</h2>
                    <h2 class="rc-keyword-tag">财务共享</h2>
                    <h2 class="rc-keyword-tag">数字化能力建设方案</h2>
                    <h2 class="rc-keyword-tag">数字化转型</h2>
                    <h2 class="rc-keyword-tag">审计数字化咨询</h2>
                    <h2 class="rc-keyword-tag">数据治理能力成熟度</h2>
                    <h2 class="rc-keyword-tag">数据合规治理体系</h2>
                    <h2 class="rc-keyword-tag">数据资产运营体系</h2>
                    <h2 class="rc-keyword-tag">数据合规</h2>
                </div>

                <div class="mt-10 flex flex-wrap gap-5">
                    <a href="#consult-form" class="px-8 py-4 bg-white text-brand rounded-lg text-base font-semibold shadow-lg hover:bg-gray-50 transition">预约专家咨询</a>
                    <a href="#subscription-anchor" class="px-8 py-4 bg-transparent text-white border-2 border-white/50 rounded-lg text-base font-semibold hover:bg-white/10 transition">查看订阅服务</a>
                </div>
                <!-- 内部链接 -->
                <div class="mt-6 text-sm text-white/70">
                    <a href="#" class="text-white hover:underline">数字化转型咨询</a> · <a href="#" class="text-white hover:underline">数据治理咨询</a> · <a href="#" class="text-white hover:underline">AI及大模型</a>
                </div>
                <p class="mt-4 text-sm text-white/70">已服务50+央企国企，包括国家能源集团、中国人寿、一汽集团等</p>
            </div>
        </div>
    </section>

    <!-- ===== 02 咨询服务内容（3-5条卡片） ===== -->
    <section class="container">
        <!-- 1. 核心服务四卡片 -->
        <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 四大咨询业务(基于AI & Data) </h2>  
        <div>
            <p class="mt-4 text-lg text-[#5A5E66]">（1）数字化转型：我们深入理解央企国企数字化进程中的真实困境。</p>
            <p class="mt-2 text-lg text-[#5A5E66]">（2）数据治理：解决百亿级企业缺少资深数据技术主管问题，长期参与企业数据驱动业务增长。</p>
            <p class="mt-2 text-lg text-[#5A5E66]">（3）AI及大模型: AI用例规划 · 大模型微调 · 工程化落地 · 团队培养</p>
            <p class="mt-2 text-lg text-[#5A5E66]">（4）数据监理: AI用例规划 · 大模型微调 · 工程化落地 · 团队培养</p>
        </div>
        <!-- 2. 核心服务四卡片 -->
        <div class="card-grid">
            <!-- 卡片1 数字化转型 -->
            <div class="service-card">
                <div class="card-icon"><i class="fa-solid fa-chart-pie"></i> 数字化转型</div>
                <h3> <span class="service-tag service-tag-gold"> 国标评估</span></h3>
                <ul class="service-features">
                    <li><i class="fa-regular fa-circle-check"></i> 数字化转型评估（国标）</li>
                    <li><i class="fa-regular fa-circle-check"></i> 数字化工程师培育（国标）</li>
                    <li><i class="fa-regular fa-circle-check"></i> 对标一流差距分析</li>
                    <li><i class="fa-regular fa-circle-check"></i> 企业数字战略制定</li>
                    <li><i class="fa-regular fa-circle-check"></i> 业务场景重构 · 技术平台选型</li>
                    <li><i class="fa-regular fa-circle-check"></i> 变革管理</li>
                </ul>
                <div class="service-footer"><a href="#" class="btn btn-outline" style="padding: 8px 24px;">了解详情</a></div>
            </div>

            <!-- 卡片2 数据治理 -->
            <div class="service-card">
                <div class="card-icon"><i class="fa-solid fa-database"></i> 数据治理咨询</div>
                <h3> 
                    <span class="service-tag"> DCMM</span>
                    <span class="service-tag"> DAMA</span>
                    <span class="service-tag"> TOGAF架构</span>
                </h3>
                <ul class="service-features">       
                    <li><i class="fa-regular fa-circle-check"></i> DCMM数据管理评估(国标)</li>
                    <li><i class="fa-regular fa-circle-check"></i> 数据战略·组织办法·标准规范</li>
                    <li><i class="fa-regular fa-circle-check"></i> 业务-IT-高层协同质量改进</li>
                    <li><i class="fa-regular fa-circle-check"></i> 蓝图规划 · 技术平台规划</li>
                    <li><i class="fa-regular fa-circle-check"></i> 指标体系 · 资产目录 · 主数据</li>
                    <li><i class="fa-regular fa-circle-check"></i> 数据标准制定</li>
                </ul>
                <div class="service-footer"><a href="#" class="btn btn-outline" style="padding: 8px 24px;">了解详情</a></div>
            </div>

            <!-- 卡片3 AI及大模型咨询 (带订阅标签) -->
            <div class="service-card" style="border-top: 5px solid var(--accent-gold);">
                <div class="card-icon"><i class="fa-solid fa-brain"></i> AI及大模型咨询</div>
                <h3> <span class="service-tag service-tag-gold">🔥 订阅</span></h3>
                <ul class="service-features">
                    <li><i class="fa-regular fa-circle-check"></i> 场景探索与路线图</li>
                    <li><i class="fa-regular fa-circle-check"></i> 模型微调 & 提示工程</li>
                    <li><i class="fa-regular fa-circle-check"></i> 应用架构设计/开发</li>
                    <li><i class="fa-regular fa-circle-check"></i> AI共创：定义问题，价值付费</li>
                    <li><i class="fa-regular fa-circle-check"></i> AI应用：AI成熟度评估</li>
                    <li><i class="fa-regular fa-circle-check"></i> AI落地：AI落地与实施</li>
                </ul>
                <div class="service-footer"><a href="#subscription-anchor" class="btn btn-outline" style="padding: 8px 24px;">了解订阅详情</a></div>
            </div>

            <!-- 卡片4 新增：数据监理服务 (支持订阅) -->
            <div class="service-card" style="border-top: 5px solid var(--accent-gold);">
                <div class="card-icon"><i class="fa-solid fa-clipboard-check"></i> 数据监理(专家服务)</div>
                <h3> <span class="service-tag service-tag-gold">🔥 订阅·长期</span></h3>
                <ul class="service-features">
                    <li><i class="fa-regular fa-circle-check"></i> 为数据驱动业务增长负责</li>
                    <li><i class="fa-regular fa-circle-check"></i> 定义AI&数据业务蓝图</li>
                    <li><i class="fa-regular fa-circle-check"></i> 深度对重点数据项目实行监理</li>
                    <li><i class="fa-regular fa-circle-check"></i> 内部数据人才培养</li>
                    <li><i class="fa-regular fa-circle-check"></i> 协助公司制定数据战略</li>
                    <li><i class="fa-regular fa-circle-check"></i> 规划数据建设工作</li>
                </ul>
                <div class="service-footer"><a href="#" class="btn btn-outline" style="padding: 8px 24px;">了解订阅详情</a></div>
            </div>
        </div>
    </section>

    <!-- 3. AI大模型订阅深度展示区 (锚点) -->
    <!-- <span id="subscription-anchor" style="position: relative; top: -40px;"></span> -->
    <section class="container">
        <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> AI大模型|Agent|Data "专家订阅"服务 </h2>   
        <div>
            <p class="mt-4 text-lg text-[#5A5E66]">业务场景：针对百亿级企业，企业面临缺乏资深数据专家、中高级专业人才短缺或缺失问题，该服务协助参与方解决项目核心、棘手难点问题，参与客户项目，承担监理角色、应对这些挑战，实现持续的业务价值创造。</p>
        </div>
        <div class="subscription-highlight">
            <h2 style="margin-bottom: 16px;"><i class="fa-regular fa-star" style="color: var(--accent-gold);"></i> AI大模型订阅服务——专家常驻，价值共创</h2>
            <p style="font-size: 1.2rem; max-width: 900px; color: #1d3d3d;">打破传统项目制咨询的周期限制，以订阅模式与您建立长期合作伙伴关系。我们派驻资深AI专家，协助您的团队持续创造业务价值，并快速响应变化。</p>

            <!-- 四大特色亮点 网格 -->
            <div class="feature-grid-4">
                <div class="feature-item"><i class="fa-solid fa-tree"></i><h4>专家常驻</h4><p>资深AI架构师、算法专家以远程或现场方式融入您的团队，成为长期技术伙伴，保障知识转移与能力沉淀。</p></div>
                <div class="feature-item"><i class="fa-solid fa-bullseye"></i><h4>创造价值</h4><p>以业务目标为导向，每个迭代周期产出可衡量的价值（效率提升、成本降低、新收入机会），定期复盘调整。</p></div>
                <div class="feature-item"><i class="fa-solid fa-code"></i><h4>AI及LLM协助开发交付</h4><p>不仅提供咨询，更协助开发团队完成AI应用设计、微调、开发与部署，确保大模型能力快速落地。</p></div>
                <div class="feature-item"><i class="fa-solid fa-laptop"></i><h4>远程支持</h4><p>高效远程协作机制（每日站会、敏捷看板、即时沟通），确保响应速度的同时降低服务成本，灵活适配团队节奏。</p></div>
            </div>

            <!-- 订阅服务包含内容 + 模式优势 左右分区 -->
            <div class="content-list-split">
                <div>
                    <h4 style="font-size: 1.4rem; margin-bottom: 20px;"><i class="fa-regular fa-rectangle-list"></i> 订阅包含内容</h4>
                    <ul class="included-list">
                        <li><i class="fa-regular fa-circle-check"></i> AI应用场景探索与路线图规划</li>
                        <li><i class="fa-regular fa-circle-check"></i> 大模型选型、微调与提示工程</li>
                        <li><i class="fa-regular fa-circle-check"></i> 模型评估、安全与伦理审查</li>
                        <li><i class="fa-regular fa-circle-check"></i> AI应用架构设计与技术选型</li>
                        <li><i class="fa-regular fa-circle-check"></i> MLOps/LLMOps 支持与自动化流水线搭建</li>
                        <li><i class="fa-regular fa-circle-check"></i> 团队AI能力培训与技术答疑</li>
                    </ul>
                </div>
                <div>
                    <h4 style="font-size: 1.4rem; margin-bottom: 20px;"><i class="fa-regular fa-gem"></i> 订阅模式优势</h4>
                    <div class="badge-group">
                        <span class="badge">灵活周期 (季/半年/年)</span>
                        <span class="badge">成本可预测</span>
                        <span class="badge">快速启动 (1-2周入驻)</span>
                        <span class="badge">持续创新迭代</span>
                    </div>
                    <p style="margin-top: 30px;">每个订阅周期设定明确的价值里程碑，配备客户成功经理保障体验。</p>
                </div>
            </div>

            <h2 style="text-align: center;"><i class="fa-regular fa-compass"></i> 订阅服务流程</h2>
            <div class="steps">
                <div class="step"><div class="step-number">1</div><h4 class="text-xl font-bold text-[#0E1F52]">预约沟通</h4><p>填写需求或预约专家会谈，了解业务场景与期望。</p></div>
                <div class="step"><div class="step-number">2</div><h4 class="text-xl font-bold text-[#0E1F52]">定制方案</h4><p>共同确定服务范围、专家级别、订阅周期与交付物。</p></div>
                <div class="step"><div class="step-number">3</div><h4 class="text-xl font-bold text-[#0E1F52]">专家入驻</h4><p>匹配专属AI专家，启动线上/线下协作，快速融入团队。</p></div>
                <div class="step"><div class="step-number">4</div><h4 class="text-xl font-bold text-[#0E1F52]">持续交付</h4><p>按敏捷迭代推进，定期回顾价值成果，灵活调整方向。</p></div>
            </div>

            <!-- 行动按钮 -->
            <div style="text-align: center;">
                <a href="#" class="btn btn-accent" style="padding: 16px 48px; font-size: 14px;">定制您的订阅计划 <i class="fa-regular fa-hand-point-right"></i></a>
            </div>
        </div>
    </section>

    <!-- ===== 05 客户成功案例 ===== -->
    <section class="container">
        <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 客户案例（咨询服务）</h2>           
        <div>
            <p class="mt-4 text-lg text-[#5A5E66]">古杉数据"创新性咨询POC方法论"</p>
        </div>
        <!-- 5. 客户成功案例 (3个) -->
        <div class="container">
            <div class="case-grid">
            <div class="case-card">
                <i class="fa-solid fa-building-columns" style="font-size: 2rem; color: var(--primary-dark);"></i>
                <div class="case-stats">+45%</div>
                <p><strong>金融行业智能客服</strong> — 为头部证券企业订阅AI大模型服务，专家常驻6个月，构建基于大模型的智能问答系统，问题解决率提升45%，人力成本降低30%。</p>
            </div>
            <div class="case-card">
                <i class="fa-solid fa-cart-shopping" style="font-size: 2rem; color: var(--primary-dark);"></i>
                <div class="case-stats">+28%</div>
                <p><strong>零售业个性化推荐</strong> — 订阅模式3个月内从验证到上线，推荐点击率提升28%，并建立内部AI能力团队。</p>
            </div>
            <div class="case-card">
                <i class="fa-solid fa-gears" style="font-size: 2rem; color: var(--primary-dark);"></i>
                <div class="case-stats">-60%</div>
                <p><strong>制造业知识管理平台</strong> — 专家远程支持+现场培训，利用大模型重构企业知识库检索，工程师问题处理时间缩短60%。</p>
            </div>
            </div>
        </div>
    </section>


    <!-- ===== 04 方法论模块（SEO核心，含300字说明） ===== -->
    <section class="container">
        <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 方法论框架（数字化转型|数据管理成熟度|AI能力建设成熟度） </h2>   
            <div>
                <p class="mt-4 text-lg text-[#5A5E66]">数字化转型成熟模型 · DCMM数据管理成熟模型 · DAMA 国际数据管理，源自DCMM/DAMA、国际国内成熟的数字化转型、数据管理成熟度评估、人才标准建设评估及百家央企最佳实践</p>
            </div>
            <div class="mt-16 grid md:grid-cols-3 gap-8">
                <!-- 成熟度模型 -->
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <h3 class="text-2xl font-bold text-[#0E1F52] mb-4">数智化转型成熟度评估<br>DTMM</h3>
                    <p class="text-[#2B2F3A] leading-relaxed text-sm">
                        古杉数据数字化转型成熟度评估是基于国家标准，从组织、技术、数据、业务、资源等维度对企业数字化水平进行的系统诊断，模型从组织、技术、数据、资源、数字化运营等能力域出发，将企业成熟度划分为规范级到生态级五个等级，旨在帮助企业摸清数字化真实水平，精准定位转型短板与瓶颈明确优化方向并制定科学的升级路线图。目前，传统制造企业、响应监管要求的国有企业以及希望赋能集群的产业园区，均在积极引入此项评估，以制定科学的路径图。
                    </p>
                </div>
                <!-- 数据管理成熟度模型 -->
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <h3 class="text-2xl font-bold text-[#0E1F52] mb-4">数据管理成熟度评估<br>DCMM | DAMA </h3>
                    <p class="text-[#2B2F3A] leading-relaxed text-sm">
                        古杉数据基于DCMM国家标准和DAMA框架，将企业数据治理成熟度划分为五个等级：初始级、受管理级、稳健级、量化管理级、优化级。通过八大能力域（数据战略、数据治理、数据架构、数据标准、数据质量、数据安全、数据应用、数据生命周期）的全面评估，帮助企业定位当前阶段，制定进阶路线。我们已为30+央企完成成熟度评估，并成功指导多家企业通过DCMM四级认证。
                    </p>
                </div>
                <!-- 五大能力域 -->
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <h3 class="text-2xl font-bold text-[#0E1F52] mb-4">数据&AI成熟度评估<br>DAMA</h3>
                    <p class="text-[#2B2F3A] leading-relaxed text-sm">
                        人工智能成熟度评估遵从国家标准,内容涵盖人工智能服的战略与治理、数据集管理、资源保障、风险管理、业务应用、系统生存周期、安全可信、合规管理等能力域，将成熟度划分为初始级至引领级五个等级。旨在帮助企业摸清人工智能应用现状，精准定位能力短板，提升系统可信与安全水平。目前，金融、制造、零售、健康等行业的领先企业（如太平洋保险、兴业银行、欧莱雅等）积极开展此项评估，推动从“+AI”向“AI+”的价值跃迁。
                    </p>
                </div>
            </div>
    </section>

    <!-- ===== 06 成功案例（行业标签） ===== -->
    <section class="container">
        <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 成功案例（行业领军者共同选择）</h2>
        <div class="mt-16 grid md:grid-cols-2 gap-8">
            <!-- 能源案例 -->
            <div class="bg-white p-7 rounded-xl border border-divider flex flex-col sm:flex-row gap-5 items-start">
                <span class="text-4xl bg-porcelain w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">⚡</span>
                <div>
                    <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">能源 · 数据治理</span>
                    <h3 class="text-xl font-bold text-[#0E1F52] mt-2">国家能源集团 · 数据治理体系</h3>
                    <p class="mt-2 text-sm text-[#5A5E66]">建立集团统一数据标准与指标库，主数据平台覆盖10+业务板块，通过DCMM四级认证。</p>
                </div>
            </div>
            <!-- 央企集团案例 -->
            <div class="bg-white p-7 rounded-xl border border-divider flex flex-col sm:flex-row gap-5 items-start">
                <span class="text-4xl bg-porcelain w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">🏛️</span>
                <div>
                    <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">央企集团 · 数字化转型</span>
                    <h3 class="text-xl font-bold text-[#0E1F52] mt-2">某央企集团 · 数字化规划</h3>
                    <p class="mt-2 text-sm text-[#5A5E66]">完成集团数字化顶层设计，制定三年实施路线图，统筹15家二级单位的数据治理与平台建设。</p>
                </div>
            </div>
                        <!-- 银行案例 -->
            <div class="bg-white p-7 rounded-xl border border-divider flex flex-col sm:flex-row gap-5 items-start">
                <span class="text-4xl bg-porcelain w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">🏦</span>
                <div>
                    <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">银行 · 数字化转型</span>
                    <h3 class="text-xl font-bold text-[#0E1F52] mt-2">某国有大行 · 审计数字化转型</h3>
                    <p class="mt-2 text-sm text-[#5A5E66]">构建全行非现场审计平台，部署300+审计模型，审计覆盖率从15%提升至85%，问题发现效率提高70%。</p>
                </div>
            </div>
            <!-- 保险案例 -->
            <div class="bg-white p-7 rounded-xl border border-divider flex flex-col sm:flex-row gap-5 items-start">
                <span class="text-4xl bg-porcelain w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">🛡️</span>
                <div>
                    <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">保险 · 风控体系重构</span>
                    <h3 class="text-xl font-bold text-[#0E1F52] mt-2">中国人寿 · 实时风控平台</h3>
                    <p class="mt-2 text-sm text-[#5A5E66]">建立风险指标监测体系，实现退保、给付异常实时预警，年拦截风险交易超2万笔。</p>
                </div>
            </div>
        </div>
    </section>

    <!-- ===== 08 专家团队 ===== -->
    <section class="container">
        <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 专家咨询团队</h2>
        <div>
            <p class="mt-4 text-lg text-[#5A5E66]">平均10年以上技术（AI & Data & Analytics 相关领域）、丰富德行业经验</p>
        </div>
        <div class="mt-16 grid md:grid-cols-3 gap-8">
            <div class="text-center">
                <div class="w-32 h-32 mx-auto bg-porcelain rounded-full flex items-center justify-center text-5xl mb-4">👤</div>
                <h3 class="text-xl font-bold text-[#0E1F52]">张建国</h3>
                <p class="text-brand text-sm">首席数据治理专家</p>
                <p class="mt-2 text-sm text-[#5A5E66]">前德勤咨询总监，主导国家电网、华润集团数据治理项目，DCMM评估师。</p>
            </div>
            <div class="text-center">
                <div class="w-32 h-32 mx-auto bg-porcelain rounded-full flex items-center justify-center text-5xl mb-4">👤</div>
                <h3 class="text-xl font-bold text-[#0E1F52]">李慧</h3>
                <p class="text-brand text-sm">审计数字化负责人</p>
                <p class="mt-2 text-sm text-[#5A5E66]">原普华永道审计合伙人，为工农中建、中国人寿提供审计数字化转型咨询。</p>
            </div>
            <div class="text-center">
                <div class="w-32 h-32 mx-auto bg-porcelain rounded-full flex items-center justify-center text-5xl mb-4">👤</div>
                <h3 class="text-xl font-bold text-[#0E1F52]">王峰</h3>
                <p class="text-brand text-sm">风控与合规首席</p>
                <p class="mt-2 text-sm text-[#5A5E66]">前IBM风险咨询总监，服务中国平安、国家开发银行等风控体系建设项目。</p>
            </div>
        </div>
    </section>


    <!-- 6. 常见问题 FAQ (精简) -->
    <section class="container">
        <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 常见问题</h2>    
        <div class="faq-list">
            <div class="faq-item">
                <div class="faq-question"><i class="fa-regular fa-message"></i> 订阅模式与传统咨询有何不同？</div>
                <div class="faq-answer">订阅模式更强调长期伙伴关系，专家常驻团队，按需灵活调整服务内容，避免一次性项目交付后无人跟进的问题。同时成本更可控，适合持续迭代的AI项目。</div>
            </div>

            <div class="faq-item">
                <div class="faq-question"><i class="fa-regular fa-message"></i> 专家常驻是远程还是现场？</div>
                <div class="faq-answer">两者皆可。我们根据客户需求与项目阶段灵活安排，通常以远程为主并定期现场工作，确保效率与成本平衡。</div>
            </div>
            
            <div class="faq-item">
                <div class="faq-question"><i class="fa-regular fa-message"></i> 数据监理服务是否也支持订阅？</div>
                <div class="faq-answer">是的，数据监理服务同样采用订阅模式，可以按季度或年度签约，资深数据技术主管长期参与企业数据驱动增长，深度监理重点项目并培养内部团队。</div>
            </div>
            
            <div class="faq-item">
                <div class="faq-question"><i class="fa-regular fa-message"></i> 如何确保服务质量与价值创造？</div>
                <div class="faq-answer">每个订阅周期设定明确的价值里程碑，定期与客户共同复盘。同时配备客户成功经理，保障服务体验。</div>
            </div>
            
            <div class="faq-item">
                <div class="faq-question"><i class="fa-regular fa-message"></i> 什么是数据治理？</div>
                <div class="faq-answer">数据治理是指对数据资产进行管理和控制的一系列活动，包括数据标准、数据质量、数据安全、数据生命周期等。它旨在确保数据的准确性、一致性、可用性和安全性，使数据成为可信的决策依据。古杉数据基于DCMM/DAMA框架，为企业提供从咨询到落地的全流程数据治理服务，帮助央企国企构建数据治理体系。</div>
            </div>
            
            <div class="faq-item">
                <div class="faq-question"><i class="fa-regular fa-message"></i> 数据治理咨询费用是多少？</div>
                <div class="faq-answer">数据治理咨询费用根据企业规模、业务复杂度和咨询范围而定。通常包括现状评估、体系设计、实施规划等阶段。古杉提供灵活的报价方案，基础咨询项目通常在30-80万区间，大型集团级项目可能涉及百万级投资。我们建议您预约专家进行初步沟通，我们将根据您的具体需求提供定制化报价。</div>
            </div>
            
            <div class="faq-item">
                <div class="faq-question"><i class="fa-regular fa-message"></i> 咨询项目通常周期多久？</div>
                <div class="faq-answer">根据项目范围，一般咨询项目周期为2-6个月。其中现状调研与诊断约3-4周，体系设计1-2个月，实施规划与试点支持2-3个月。具体周期会在项目启动前与客户共同确认。</div>
            </div>
            
            <div class="faq-item">
                <div class="faq-question"><i class="fa-regular fa-message"></i> 央企如何做数字化转型？</div>
                <div class="faq-answer">根据项目范围，一般咨询项目周期为2-6个月。其中现状调研与诊断约3-4周，体系设计1-2个月，实施规划与试点支持2-3个月。具体周期会在项目启动前与客户共同确认。</div>
            </div>
        </div>
    </section>

    <!-- ===== 10 底部转化模块 ===== -->
    <section id="contact" class="container cta-section">
      <h2 style="text-align: center;"><i class="fa-regular"></i> 预约咨询</h2>  
      <div class="cta-inner">
        <h3 class="cta-heading">构建可信、统一的数据治理与 AI 治理体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>咨询方向</label>
            <select>
              <option value="">-- 请选择咨询方向 --</option>
              <option>顶层设计 / 数据战略规划</option>
              <option>数据标准与数据质量</option>
              <option>主数据管理</option>
              <option>数据资产盘点 / DCMM 评估</option>
              <option>AI 治理与大模型应用</option>
              <option>数据监理服务</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「数据治理」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>

</template>

<script>
export default {
  name: 'Consult',
  data() {
    return {
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')]
    }
  },
  methods: {
    submitForm() {
      alert('表单已提交')
      this.showModal = false
    },
    showQrCode() {
      this.showQrModal = true
    }
  }
}
</script>

<style scoped>
    /* 青花瓷色系变量 */
    .consult-page {
    --brand-blue: #1F3F8F;
    --deep-indigo: #0E1F52;
    --porcelain-blue: #EAF0FB;
    --ink-blue-gray: #2B2F3A;
    --white: #FFFFFF;
    --gray-bg: #F6F8FC;
    --divider: #E6EAF2;

    --primary-dark: #1D4E4E;      /* 深青主色 */
    --primary-soft: #e9f3f2;      /* 浅青背景 */
    --accent-gold: #D4AF37;       /* 金色点缀 */
    --accent-blue: #2A7DE1;       /* 亮蓝创新 */
    --gray-light: #f8fafc;
    --gray-border: #e2e8f0;
    --text-dark: #0f2a2a;
    --text-regular: #2d3f4b;
    --white: #ffffff;
    --shadow: 0 12px 30px rgba(0, 40, 40, 0.06);
    }

    .section {
    max-width: 1200px;
    margin-bottom: 100px;
    scroll-margin-top: calc(60px + 20px);
    opacity: 1;
    transform: translateY(0);
    animation: sectionFadeIn 0.5s ease-in-out forwards;
    }

    @keyframes sectionFadeIn {
      from {
        opacity: 0;
        transform: translateY(15px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    h2 {
    font-size: 28px;
    font-weight: 700;
    color: #0E1F52;
    margin-top: 20px;
    margin-bottom: 20px;
    letter-spacing: -0.01em;
    position: relative;
    display: inline-block;
    }

    h2:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 3px;
    background-color: #1F3F8F;
    border-radius: 4px;
    }



    .bg-porcelain { 
    background-color: var(--porcelain-blue); 
    }

    .bg-brand { 
    background-color: #1F3F8F; 
    }

    .text-brand { 
    color: #1F3F8F; 
    }

    .border-divider { 
    border-color: #E6EAF2; 
    }

    .card-hover { 
    transition: all 0.25s; 
    }

    .card-hover:hover {
    box-shadow: 0 20px 30px -10px rgba(31, 63, 143, 0.08);
    border-color: transparent;
    }

    .gradient-blue {
        background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
    /*  max-width: 1200px; */
        max-width: 100%;
        margin: 0 auto;
    }

    .gradient-light {
    background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
    }

    /* 通用样式 */
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 20px 16px;
      
    }


    /* ========== 区块标题（替代 h2-1 自定义标签） ========== */
    .section-title {
        font-size: 28px;
        font-weight: 700;
        color: #0E1F52;
        margin-bottom: 40px;
        letter-spacing: -0.01em;
        position: relative;
        display: inline-block;
    }

    .section-title::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 60px;
        height: 3px;
        background-color: #1F3F8F;
        border-radius: 4px;
    }


    /* 卡片网格 (四列) */
    .card-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 24px;
        margin: 40px 0 20px;
        padding: 24px;
        background: var(--gray-bg); /* 添加深灰色背景 */
    }

    .service-card {
        background: white;
        border-radius: 24px;
        padding: 28px 20px;
        box-shadow: var(--shadow);
        border: 1px solid var(--gray-border);
        transition: transform 0.2s;
        display: flex;
        flex-direction: column;
    }

    .service-card:hover {
        transform: translateY(-6px);
        box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
    }

    .card-icon {
        font-size: 20px;
        color: #0E1F52;
        margin-bottom: 20px;
    }

    .service-tag {
        background: var(--accent-gold);
        color: #1e3c3c;
        font-size: 0.7rem;
        font-weight: 700;
        padding: 4px 10px;
        border-radius: 40px;
        display: inline-block;
        margin-left: 8px;
        vertical-align: middle;
        text-transform: uppercase;
    }

    .service-tag-gold {
        background: #D4AF37;
        color: white;
    }

    .service-features {
        list-style: none;
        margin: 16px 0 24px;
        flex-grow: 1;
    }

    .service-features li {
        margin-bottom: 8px;
        font-size: 0.9rem;
        display: flex;
        gap: 8px;
    }

    .service-features i {
        color: var(--primary-dark);
        font-size: 0.85rem;
        margin-top: 4px;
        min-width: 18px;
    }

    .service-footer {
        margin-top: auto;
    }

        /* 订阅特色区域 */
    .subscription-highlight {
        background-color: var(--gray-bg); /* 添加深灰色背景 */
        border-radius: 48px;
        padding: 56px 48px;
        margin: 48px 0;
    }

    .feature-grid-4 {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 24px;
        margin: 48px 0 40px;
    }

    .feature-item {
        background: white;
        border-radius: 28px;
        padding: 28px 20px;
        box-shadow: 0 6px 16px rgba(0,0,0,0.02);
    }

    .feature-item i {
        font-size: 2.2rem;
        color: var(--primary-dark);
        margin-bottom: 20px;
    }

    .feature-item h4 {
        font-size: 1.3rem;
        margin-bottom: 10px;
        color: var(--text-dark);
    }

    .feature-item p {
        color: #3b4d5c;
        font-size: 0.95rem;
    }

    .content-list-split {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 30px;
        background: white;
        border-radius: 32px;
        padding: 36px 40px;
        margin: 32px 0;
    }

    .included-list {
        list-style: none;
    }

    .included-list li {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 1rem;
    }

    .included-list i {
        color: var(--accent-blue);
        width: 22px;
    }

    .badge-group {
        display: flex;
        flex-wrap: wrap;
        gap: 14px;
        margin-top: 16px;
    }

    .badge {
        background: #e9f3f2;
        color: var(--primary-dark);
        padding: 8px 18px;
        border-radius: 40px;
        font-weight: 600;
        font-size: 0.9rem;
    }

    .steps {
        display: flex;
        justify-content: space-between;
        margin: 48px 0 24px;
        gap: 15px;
    }

    .step {
        flex: 1;
        text-align: center;
        position: relative;
    }

    .step-number {
        width: 50px;
        height: 50px;
        background: #1F3F8F;
        color: white;
        border-radius: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.4rem;
        font-weight: 400;
        margin: 0 auto 18px;
    }

    .btn {
      display: inline-block;
      padding: 12px 30px;
      border-radius: 40px;
      font-weight: 600;
      text-decoration: none;
      transition: all 0.2s;
      font-size: 1rem;
      border: 1px solid transparent;
      cursor: pointer;
    }

    .btn-primary {
      background-color: var(--primary-dark);
      color: white;
      box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
    }

    .btn-primary:hover {
      background-color: #0e3a3a;
      transform: translateY(-2px);
    }

    .btn-outline {
      background-color: transparent;
      border: 1.5px solid var(--primary-dark);
      color: var(--primary-dark);
    }

    .btn-outline:hover {
      background-color: var(--primary-dark);
      color: white;
    }

    .btn-accent {
      background-color: #2A7DE1;       /* 亮蓝创新 */
      color: white;
      box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
    }

    .btn-accent:hover {
      background-color: #1b64c5;
      transform: translateY(-2px);
    }

      /* 案例卡片 */
    .case-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      margin-top: 0px;
    }

    .case-card {
      background: white;
      border-radius: 24px;
      padding: 28px;
      box-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);
    }

    .case-stats {
      font-size: 1.8rem;
      font-weight: 700;
      color: var(--primary-dark);
      margin: 16px 0 8px;
    }

    /* FAQ */
    .faq-list {
      max-width: 900px;
      margin: 40px auto 0;
    }

    .faq-item {
      padding: 22px 0;
      border-bottom: 1px solid var(--gray-border);
    }

    .faq-question {
      font-weight: 700;
      font-size: 1.2rem;
      display: flex;
      gap: 16px;
      color: var(--text-dark);
    }

    .faq-question i {
      color: var(--accent-gold);
    }

    .faq-answer {
      margin-top: 12px;
      color: #3f5465;
      padding-left: 40px;
    }

    
/* 关键词标签云 */
.rc-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.rc-keyword-tag {   
  background: white;
  color: var(--rc-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.rc-keyword-tag.highlight {
  background: #D4AF37;
  color: #1e3c3c;
}


/* 底部转化 */

.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}


.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 30px 0;
  flex-wrap: wrap;
}

.qr-code {
  display: inline-block;
  background: #EAF0FB;
  padding: 12px 24px;
  border-radius: 60px;
  margin-top: 20px;
  cursor: pointer;
  color: var(--deep-indigo);
  text-align: center;
}


.btn-primary {
  display: inline-block;
  background: #1F3F8F;
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(31,63,143,0.3);
}

.btn-outline-light {
  background: #EAF0FB;
  color: black;
  border: 1px solid #0e3170;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  text-decoration: none;
}
.btn-outline-light:hover {
  background: rgba(255,255,255,0.1);
  border-color: #0e3170;
}

/* ============ CTA 转化部分 ============ */
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-badge {
  display: inline-block;
  background: rgba(31,63,143,0.08);
  border: 1px solid rgba(31,63,143,0.18);
  color: #1F3F8F;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: 20px;
  margin-bottom: 18px;
  letter-spacing: 0.6px;
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}

/* 弹窗头部 */
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}

/* 标题尺寸 */
h1 {
    font-size: 42px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;
    margin-bottom: 24px;
    color: #0b1a33;
}

</style>